@if (loading()) {
  <div class="loading">
    <ngx-loading />
    <span animate.enter="fade-in" animate.leave="fade-out">&nbsp;{{ "TOPNAV.TITLE" | translate }}&nbsp;</span>
  </div>
}
<router-outlet />
